import React, { PropsWithChildren } from 'react';

import { GingerAdEvent } from '@/core/components/Ad/GingerAd';
import api from '@/core/lib/fetch/api';

export interface AdLinkWithStatsApiCallProps extends PropsWithChildren {
  href: string;
  adData?: GingerAdEvent;
  apiUrl?: string;
}

const AdLinkWithStatsApiCall: React.FC<AdLinkWithStatsApiCallProps> = ({ href, adData, children, apiUrl }) => {
  const handleOnClick = async () => {
    if (apiUrl && adData) {
      try {
        await api.post({ url: apiUrl, data: { adData } });
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <a href={href} target="_blank" rel="noreferrer" onClick={handleOnClick}>
      {children}
    </a>
  );
};

export default AdLinkWithStatsApiCall;
